"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaginationComponent = void 0;
const React = __importStar(require("react"));
const Elements = __importStar(require("../elements"));
const LocalElements = __importStar(require("./elements"));
const LanguageTexts = __importStar(require("@genesys/shared/lib/language-texts"));
const Contexts = __importStar(require("../contexts"));
function render({ currentPage, itemsPerPage, onPageChange, onRefresh, numberOfPages, totalItems, children }) {
    const minItem = currentPage * itemsPerPage - itemsPerPage + 1;
    const maxItem = currentPage * itemsPerPage;
    return (React.createElement(Contexts.TranslateContext.Consumer, null, translate => (React.createElement(Elements.ManagerSearchControlsContainer, null,
        React.createElement(Elements.FlexContainerRow, null,
            React.createElement(LocalElements.ControllerContainer, null,
                React.createElement(Elements.ManagerSearchControlsButtonContainer, { onClick: onRefresh },
                    React.createElement("img", { src: "/assets/images/refresh.png" }))),
            children &&
                children.map(c => (React.createElement(LocalElements.ControllerContainer, { key: c.key }, c)))),
        React.createElement("div", null,
            React.createElement(Elements.ManagerSearchResultPagingText, null,
                React.createElement("span", null,
                    minItem,
                    " - ",
                    Math.min(maxItem, totalItems)),
                " ",
                translate(LanguageTexts.of()),
                " ",
                React.createElement("span", null, totalItems),
                " (",
                React.createElement("span", null, numberOfPages),
                " ",
                translate(LanguageTexts.pages()),
                ")"),
            React.createElement(Elements.ManagerSearchControlsPagingButtonContainer, { disabled: currentPage <= 1, onClick: () => onPageChange(currentPage - 1) },
                React.createElement("img", { src: "/assets/images/previous-page.png" })),
            React.createElement(Elements.ManagerSearchControlsPagingInput, { type: "text", readOnly: true, value: currentPage }),
            React.createElement(Elements.ManagerSearchControlsPagingButtonContainer, { disabled: currentPage >= numberOfPages, onClick: () => onPageChange(currentPage + 1) },
                React.createElement("img", { src: "/assets/images/next-page.png" })))))));
}
exports.PaginationComponent = render;
//# sourceMappingURL=pagination-component.js.map